import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IdentityService } from 'src/app/core/services/identity.service';
import { NativeBridgeService } from '../services/native-bridge.service';
import { CacheControlService } from '../services/cache-control.service';
import { NotificationService } from '../services/notification.service';
import { deviceMessageId } from '../enums/device-message-id.enum';

const NEW_VERSION: string = 'new_version';
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  constructor(
    private identityService: IdentityService,
    private notification: NotificationService,
    private router: Router,
    private cacheService: CacheControlService,
    private bridgeService: NativeBridgeService
  ) {}

  handleError400(error: HttpErrorResponse) {
    console.log(error);
    switch (error.error.resultCode) {
      case -1001:
        this.cacheService.showDialog(NEW_VERSION);
        break;
      default:
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          errorMessage = `Error al solicitar servicio. El cliente no ha sido capaz de comunicarse con el servidor`;
        } else {
          errorMessage = error.error.message;
        }
        this.notification.showError(errorMessage);
        break;
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> | any {
    let request;

    const token = this.identityService.getToken();
    if (token != undefined) {
      request = req.clone({
        headers: req.headers
          .set(IdentityService.AUTHORIZATION, `Bearer ${token}`)
          .set('client-version', require('../../../../package.json').version)
          .set('client-platform', 'PIX')
          .set('No-Auth', 'True')
      });
    } else {
      request = req.clone({
        headers: req.headers
          .set('client-version', require('../../../../package.json').version)
          .set('client-platform', 'PIX')
          .set('No-Auth', 'True')
      });
    }
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 401:
              this.notification.showError('Sesión expirada.', 'Por favor vuelva a ingresar');
              console.error('Error de autorización: ', error);

              this.identityService.clearSession();
              if (
                this.bridgeService &&
                (this.bridgeService.nativeBridgeIsActive('androidBridge') ||
                  this.bridgeService.nativeBridgeIsActive('iOSBridge'))
              ) {
                this.bridgeService.sendMessageToDevice(JSON.stringify({ message_id: deviceMessageId.USER_SIGN_OUT }));
                console.log('Sent userSignOut to bridge');
              } else {
                console.warn('Bridge no disponible, solo navega a login');
              }
              this.router.navigateByUrl('/login');
              return throwError({ status: 401, message: 'Sesión expirada.Por favor vuelva a ingresar' });
            case 0:
              if (error.statusText === 'Unknown Error') {
                this.notification.showError('Url de solicitud inválida', 'Error del cliente');
                console.error(
                  'Recurso no encontrado (404) el cliente ha sido capaz de comunicarse con el servidor, pero no existe el recurso que ha sido pedido: ',
                  error
                );
                return throwError({ status: 404, message: 'Endpoint inválido o inexistente.' });
              }
              break;
            case 500:
              this.notification.showError('Error del servidor, por favor intente mas tarde.', 'Excepcion recibida');
              console.error(
                'Error interno de servidor (500) el servidor encontró una condición inesperada que le impidió cumplir con la solicitud: ',
                error
              );
              return throwError({ status: 500, message: 'Excepcion del servidor' });
            case 400:
              this.handleError400(error);
              return;
            default:
              break;
          }
        }
      })
    );
  }
}
